import { initializeApp } from 'firebase/app'
import { getMessaging, getToken } from 'firebase/messaging'

const firebaseConfig = {
  apiKey: 'AIzaSyAOLRRTLmI7SowGZXQ-rmv9b2_2VIq1x2U',
  authDomain: 'checkmarq-62c35.firebaseapp.com',
  projectId: 'checkmarq-62c35',
  storageBucket: 'checkmarq-62c35.appspot.com',
  messagingSenderId: '360674412876',
  appId: '1:360674412876:web:d6d9987f7f097e824327e9',
  measurementId: 'G-4FDL55565P',
}

const firebaseApp = initializeApp(firebaseConfig)
export const messaging = getMessaging(firebaseApp)

export const getTokenInit = () => {
  return getToken(messaging, {
    vapidKey:
      'BLWkTbu2eyvP91zDksmfNLLNeeEY3Si2PSOSS-PWLiJKpb1xRpPUL17jpcQu8HmPWTkDTDjFMh27WZbJvsPO020',
  })
}
